import apis from './requests';

import { hasErrors } from './middlewares';
import { extendExpiration } from '../models/factory';

export { getBaseURL } from './endpoints';
export { endpoints } from './endpoints';

export async function post (endpoint, body, options, store ) {
    extendExpiration();
    const res = await apis.post(endpoint, body, options);
    if (hasErrors(res, store)) {
        return { error: true };
    }
    return res;
}

export async function get (endpoint, body, options, store ) {
    extendExpiration();
    const res = await apis.get(endpoint, options);
    if (hasErrors(res, store)) {
        return { error: true };
    }
    return res;
}

export async function upload (endpoint, formdata, options, store ) {
    extendExpiration();
    const res = await apis.upload(endpoint, formdata, options);
    if (hasErrors(res, store)) {
        return { error: true };
    }
    return res;
}

export async function put (endpoint, body, options, store ) {
    extendExpiration();
    const res = await apis.put(endpoint, body, options);
    if (hasErrors(res, store)) {
        return { error: true };
    }
    return res;
}

export async function deleteAPI (endpoint, options, store ) {
    extendExpiration();
    const res = await apis.deleteAPI(endpoint, options);
    if (hasErrors(res, store)) {
        return { error: true };
    }
    return res;
}

export async function gqlGet (endpoint, query, options, store ) {
    extendExpiration();
    const res = await apis.gqlGet(endpoint, query, options);
    if (hasErrors(res, store)) {
        return { error: true };
    }
    return res;
}

export async function gqlPost (endpoint, query, options, store ) {
    extendExpiration();
    const res = await apis.gqlPost(endpoint, query, options);
    if (hasErrors(res, store)) {
        return { error: true };
    }
    return res;
}

const withMiddlewares = {
    post,
    get,
    upload,
    put,
    deleteAPI,
    gqlPost,
    gqlGet,
};


export default withMiddlewares;
